<template>
  <div class="bgc score">
    <Loading v-if="loading" />

    <div class="title">
      <div class="sort_son_title">
        {{ itemTitle }}
      </div>
      <div class="right_div">
        <a-button
          v-if="tableData && tableData.length"
          class="btn"
          type="primary"
          ghost
          @click="importTo"
        >
          {{ $t('exam.downbtn') + itemTitle }}
        </a-button>
      </div>
    </div>

    <div class="table_div">
      <Table
        ref="table"
        :columns="columns"
        :pagination="false"
        :data="tableData"
      />
      <div v-if="showChart" class="echarts">
        <div ref="chart" class="echarts_list"></div>
      </div>
      <a-modal
        v-model="showScore"
        centered
        :mask-closable="true"
        :title="$t('exam.qusMOdalTit')"
        class="test_modal"
        :width="1200"
        footer=""
      >
        <label> {{ $t('exam.qusModalLabel') }} ：</label>
        <a-select v-model="type" style="width: 200px" @change="getAnalyse">
          <a-select-option
            v-for="item in typeList"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
        <div class="scoreTable">
          <Table :columns="columns2" :pagination="false" :data="tableData2" />
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
  import axios, { getCookie } from '@utils'
  import ApiXy from '@lib/api.js'
  import Table from '@comp/tables/questionRateTable.vue'
  import * as echarts from 'echarts'
  import Loading from '@comp/loading'
  export default {
    components: {
      Table,
      Loading
    },
    props: {
      id: {
        type: String,
        default: ''
      },
      itemTitle: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        showChart: true,
        loading: false,
        type: 1,
        typeList: [...this.$t('exam.qustypeList')],
        showScore: false,
        row: {},
        columns2: [],
        tableData2: [],
        // title: '题目层次得分率',
        columns: [
          {
            title: this.$t('exam.quesRateColum[0]'),
            dataIndex: 'className',
            customRender: text => {
              return <div>{text + this.$t('exam.allStuText')}</div>
            }
          },
          {
            title: this.$t('exam.quesRateColum[1]'),
            dataIndex: 'topicHierarchyName'
          },
          {
            title: this.$t('exam.quesRateColum[2]'),
            dataIndex: 'questionIndex',
            customRender: (text, row) =>
              this.renderFc(text, row, 'questionIndex')
          },
          {
            title: this.$t('exam.quesRateColum[3]'),
            dataIndex: 'classAvg',
            customRender: (text, row) => this.renderFc(text, row, 'classAvg')
          },
          {
            title: this.$t('exam.quesRateColum[4]'),
            dataIndex: 'scoreRate',
            customRender: (text, row) => this.renderFc(text, row, 'scoreRate')
          },
          {
            title: this.$t('exam.quesRateColum[5]'),
            dataIndex: 'topicHierarchyScore'
          }
        ],
        tableData: [],
        query: {},
        chartList: [],
        colorList: [],
        dList: [],
        splitNum: 7
      }
    },
    watch: {
      $route() {
        this.getCompetencylevel()
      }
    },
    created() {
      this.query = this.$route.query

      let { examIsActive } = this.$route.query

      if (examIsActive == 1) {
        this.columns[0].title = '学校'
        this.columns[3].title = '学校平均分'
      }
    },
    mounted() {
      this.getCompetencylevel()
    },
    methods: {
      beforeEchart(data, yTitle, params = {}) {
        let {
          split = true,
          splitNum = this.splitNum,
          abs = false,
          labelFc = null
        } = params
        let top
        if (data.legend && data.legend.data) {
          let baseNum = Math.ceil(data.legend.data.length / 10)
          top = baseNum * 40 + 24
        }
        //echarts距离处理
        data.grid = {
          top: data.legend ? top : 24,
          bottom: 28,
          left: '3.6%',
          right: '3.5%'
        }
        //x轴处理
        if (Array.isArray(data.xAxis)) {
          data.xAxis.forEach(item => {
            xDataDispose(item)
          })
        } else {
          xDataDispose(data.xAxis)
        }
        //x轴数据处理
        function xDataDispose(xData) {
          if (!xData.axisLabel) xData.axisLabel = {}
          xData.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 14
          }
          xData.axisTick = {
            show: false
          }
          !xData.offset && (xData.offset = 4)
          if (!xData.axisLine) {
            xData.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              }
            }
          }
        }

        //Y轴处理
        if (!data.yAxis) data.yAxis = {}
        if (Array.isArray(data.yAxis)) {
          data.yAxis.forEach(item => {
            yDataDispose(item)
          })
        } else {
          yDataDispose(data.yAxis)
        }
        //y轴数据处理
        function yDataDispose(yData) {
          if (!yData.splitLine) {
            yData.splitLine = {
              show: false
            }
          }

          if (!yData.axisLabel) yData.axisLabel = {}
          yData.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 12
          }
          if (!yData.axisLine) {
            yData.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              },
              itemStyle: {
                color: '#666666'
              }
            }
          }
          if (!yData.splitArea) {
            yData.splitArea = {
              show: true,
              areaStyle: {
                color: ['#A78BFA', '#fff'],
                opacity: 0.04
              }
            }
          }
        }

        //分割处理

        if (split) {
          let max = yTitle
          if (Array.isArray(yTitle)) {
            max = Math.max(...yTitle)
          }
          if (Array.isArray(data.yAxis)) {
            data.yAxis.forEach(item => {
              labelDispose(item, max)
            })
          } else {
            let splitVal = max / splitNum
            if (abs) splitVal = splitVal * 2
            data.yAxis.max = max
            data.yAxis.interval = splitVal
            labelDispose(data.yAxis, max)
          }
        }
        function labelDispose(label, max) {
          //label处理
          label.axisLabel.formatter = value => {
            var texts = []
            let nums = Math.floor(max / splitNum)
            texts.push(+value.toFixed(nums ? 0 : 1) + (labelFc && labelFc()))
            return texts
          }
        }
      },
      //图表滚动条
      cScroll(data, xTitle, num) {
        //如果超过num个则显示滚动条
        if (xTitle.length >= num) {
          let endVal = num === 1 ? 5 : +(100 * (num / xTitle.length)).toFixed(2)
          data.grid.bottom = 64
          data.dataZoom = [
            {
              start: 0, //默认为0
              end: endVal, //默认为100
              type: 'slider',
              show: true,
              xAxisIndex: [0],
              handleIcon: `M 100, 100
                                m -75, 0
                                a 75,75 0 1,0 150,0
                                a 75,75 0 1,0 -150,0`,
              handleSize: '85%',
              handleStyle: {
                color: '#ddeeff',
                borderWidth: 0
              },
              moveHandleSize: 0, //移动手柄尺寸高度
              height: 8, //组件高度
              left: 40, //左边的距离
              right: 40, //右边的距离
              bottom: 14, //底部的距离
              fillerColor: '#ddeeff', //线条颜色
              borderColor: 'transparent', //线条边框颜色
              backgroundColor: '#F8F8F8', //两边未选中的滑动条区域的颜色
              showDataShadow: false, //是否显示数据阴影 默认auto
              showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
              realtime: true, //是否实时更新
              filterMode: 'filter',
              brushSelect: false //关闭十字架选中
            }
          ]
        }
      },
      renderFc(text, row, dataIndex, bol) {
        let isScore = row.isScoreMin !== row.isScoreMax
        let min = isScore && row.isScoreMin ? 'score minScore' : ''
        let max = isScore && row.isScoreMax ? 'score maxScore' : ''
        let min1 = row.isMin ? 'score1 minScore1' : ''
        let max1 = row.isMax ? 'score1 maxScore1' : ''
        let className = ''
        if (dataIndex === 'scoreRate') {
          className = min ? min : max ? max : min1 ? min1 : max1
        } else {
          className = min1 ? min1 : max1
        }
        if (bol) return className
        return <span class={className}>{text}</span>
      },
      showModal(row) {
        this.showScore = true
        this.row = { ...row }
        // 获取得分明细表格
        this.getAnalyse()
      },
      getAnalyse() {
        let { examIsActive } = this.$route.query
        this.columns2 = []
        let { classId, topicHierarchyId } = this.row
        let url = this.type == 1 ? 'anabyreason' : 'anabystudent'
        let params = {
          seId: this.$route.query.seId,
          classId,

          topicHierarchyId,
          campusId: this.$route.query.campusId
        }

        // 校端联考和区域端联考
        if (examIsActive * 1) {
          params.isUnion = 1
        }
        // 区域端的
        if (examIsActive * 1 == 1) {
          params.schoolId = params.classId
          params.classId = 0
        }
        axios({
          url,
          params,
          loading: true
        }).then(res => {
          if (res.status && res.data) {
            res.titles.forEach((item, i) => {
              if (i == 0) {
                this.columns2.push({
                  title: item.title,
                  dataIndex: 'reason' + i,
                  width: 100,
                  fixed: 'left'
                })
              } else {
                this.columns2.push({
                  title: item.title,
                  dataIndex: 'reason' + i,
                  width: 100,
                  customRender: text => {
                    if (text !== '') {
                      return <a-icon type="check" />
                    }
                  }
                })
              }
            })
            let arr = [{}]
            res.data.forEach((ele, i) => {
              arr[i] = {}
              ele.forEach((item, j) => {
                arr[i]['reason' + j] = item
              })
            })
            this.tableData2 = arr
          } else {
            this.tableData2 = []
          }
        })
      },
      getCompetencylevel() {
        let dataLength = 0
        this.loading = true
        let { seId, subjectId, classId, campusId, examIsActive } =
          this.$route.query
        let params = {
          seId,
          subjectId,
          classId: classId == 0 ? '' : classId,
          campusId
        }

        // 校端联考和区域端联考
        if (examIsActive * 1) {
          params.isUnion = 1
        }
        axios({
          url: 'competencylevel',
          params,
          loading: false
        })
          .then(res => {
            this.loading = false
            this.dList = JSON.parse(JSON.stringify(res.data))
            this.dList = this.dList.map(item => {
              item.className = item.className || item.SchoolName
              item.classId = item.classId || item.SchoolId

              return item
            })
            //图表数据
            let chartData = []
            //表格合并
            let colData = {
              classCol: 0,
              questionCol: 0,
              classIdx: 0,
              questionIdx: 0
            }
            let resData = []
            res.data &&
              res.data.forEach((item, index) => {
                item.className = item.className || item.SchoolName
                item.classId = item.classId || item.SchoolId
                // 班级循环
                colData.classCol = 0
                let tList = JSON.parse(JSON.stringify(item.tList)) || []
                delete item.tList
                let obj = item
                // 层次排序
                let sortlist = tList.sort(
                  (a, b) =>
                    a.topicHierarchyScore * 1 - b.topicHierarchyScore * 1
                )
                tList.forEach(itemc => {
                  // 层次循环
                  colData.questionCol = 0
                  for (let i in itemc) {
                    this.checkNumber(item[i]) && (item[i] = +item[i])
                  }
                  // 层次内的小题分 排序
                  let sortquesList = itemc.dList.sort(
                    (a, b) => a.scoreRate * 1 - b.scoreRate * 1
                  )
                  // 表示层次内小题分的最高和最低
                  // console.log(sortquesList)
                  for (let c in itemc.dList) {
                    itemc.dList[c].classAvg =
                      itemc.dList[c].classAvg || itemc.dList[c].schoolAvg
                    if (
                      itemc.dList[c] == sortquesList[0] &&
                      itemc.dList[c].scoreRate
                    ) {
                      itemc.dList[c].isScoreMin = true
                    }
                    if (
                      itemc.dList[c] == sortquesList[sortquesList.length - 1] &&
                      itemc.dList[c].scoreRate
                    ) {
                      itemc.dList[c].isScoreMax = true
                    }
                  }
                  if (itemc === sortlist[0]) {
                    itemc.isMin = true
                    for (let a in itemc.dList) {
                      itemc.dList[a].isMin = true
                    }
                  } // 层次最低
                  if (itemc === sortlist[sortlist.length - 1]) {
                    itemc.isMax = true
                    for (let a in itemc.dList) {
                      itemc.dList[a].isMax = true
                    }
                  } // 层次最高

                  itemc.topicHierarchyScore = +itemc.topicHierarchyScore
                  let dList = JSON.parse(JSON.stringify(itemc.dList)) || []
                  delete itemc.dList
                  let objc = {
                    ...obj,
                    ...itemc
                  }
                  // console.log(objc, 0)
                  /** charts数据处理start **/
                  if (index === 0) {
                    let chartObj = {
                      name: itemc.topicHierarchyName,
                      id: itemc.topicHierarchyId,
                      data: [{ ...obj, ...itemc }]
                    }
                    chartData.push(chartObj)
                  } else {
                    chartData.forEach((ct, idx) => {
                      if (ct.id === itemc.topicHierarchyId) {
                        chartData[idx].data.push({ ...obj, ...itemc })
                      }
                    })
                  }
                  /**charts数据处理end**/
                  dList.forEach(itemd => {
                    colData.classCol++
                    colData.questionCol++
                    itemd.scoreRate = +itemd.scoreRate
                    for (let i in itemd) {
                      this.checkNumber(item[i]) && (item[i] = +item[i])
                    }
                    resData.push({
                      ...objc,
                      ...itemd
                    })
                  })
                  resData[colData.questionIdx].questionSpan =
                    colData.questionCol
                  colData.questionIdx = resData.length
                })
                dataLength += colData.classCol
                resData[colData.classIdx] &&
                  (resData[colData.classIdx].classSpan = colData.classCol)
                colData.classIdx = resData.length
              })
            if (dataLength > 13) {
              this.$refs.table.height = 600
            } else {
              this.$refs.table.height = 0
            }
            this.columns = this.columns.map(cItem => {
              if (cItem.dataIndex === 'className') {
                cItem.customRender = (value, row) => {
                  const obj = {
                    children: value,
                    attrs: {}
                  }
                  obj.attrs.rowSpan =
                    row.classSpan == 1 ? null : row.classSpan || 0
                  return obj
                }
              }
              if (['topicHierarchyName'].includes(cItem.dataIndex)) {
                cItem.customRender = (value, row) => {
                  const obj = {
                    children: this.renderFc(value, row, cItem.dataIndex),
                    attrs: {}
                  }
                  obj.attrs.rowSpan =
                    row.questionSpan == 1 ? null : row.questionSpan || 0
                  return obj
                }
              }
              if (['topicHierarchyScore'].includes(cItem.dataIndex)) {
                cItem.customRender = (value, row) => {
                  let className = this.renderFc(
                    value,
                    row,
                    cItem.dataIndex,
                    true
                  )
                  var children = this.$createElement('div', {
                    domProps: {
                      innerHTML:
                        row.topicHierarchyScore +
                        '<span class="rate_icon">></span>'
                    },
                    attrs: {
                      class: `scoreRate ${className}`
                    },
                    on: {
                      click: () => {
                        this.showModal(row)
                      }
                    }
                  })
                  const obj = {
                    children,
                    attrs: {}
                  }
                  obj.attrs.rowSpan =
                    row.questionSpan == 1 ? null : row.questionSpan || 0
                  return obj
                }
              }
              return cItem
            })
            // console.log(resData, '--rd---')
            this.tableData = resData
            this.chartList = chartData
            if (this.chartList.length) {
              this.showChart = true
            } else {
              this.showChart = false
            }
            //渲染图表
            this.renderChart()
          })
          .catch(() => {
            setTimeout(() => {
              this.loading = false
            }, 200)
          })
      },
      //数字检测
      checkNumber(val) {
        let reg = /^\d+(.\d+)?$/
        return reg.test(val)
      },
      getColorRandom() {
        let cStr = () => {
          let num = parseInt(Math.random() * 255) || 1
          let str = parseInt(num, 10).toString(16)
          return str.repeat(str.length > 1 ? 1 : 2)
        }
        let colorStr = '#' + cStr() + cStr() + cStr()
        return colorStr
      },
      renderChart() {
        let series = []
        this.dList.forEach(item => {
          let obj = {
            type: 'bar',
            name: item.className,
            barGap: '15%',
            barMaxWidth: '40',
            itemStyle: {
              normal: {
                barBorderRadius: [6, 6, 0, 0]
              }
            },
            // label: {
            //   show: true,
            //   position: 'top',
            //   distance: 12,
            //   align: 'center',
            //   verticalAlign: 'middle',
            //   rotate: 0,
            //   formatter: '{@score}%'
            // },
            data: this.chartList.map(itemc => {
              let val = 0
              for (let i = 0; i < itemc.data.length; i++) {
                let itemd = itemc.data[i]
                if (itemd.classId === item.classId) {
                  val = itemd.topicHierarchyScore
                  break
                }
              }
              return val
            })
          }
          series.push(obj)
        })

        console.log(series)
        let lineChart = echarts.init(this.$refs.chart)
        let titleList = this.dList.map(item => [item.className])

        let classLen = titleList.length
        let legendBs = Math.ceil(classLen / 10)
        let legendHeight = 300 + legendBs * 50
        let legendTop = legendBs * 10

        let chartObj = {
          color: this.$store.state.echartsColor,
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
              shadowStyle: {
                shadowColor: '#ddeeff'
              }
            },
            borderWidth: 0, //设置自定义边框宽度
            backgroundColor: 'none', //设置自定义背景
            extraCssText:
              //额外附加到浮层的css样式，此处为为浮层添加阴影及padding
              'backdrop-filter: blur(10px);max-width:300px;max-height:400px;overflow:auto;',
            formatter: params => {
              var relVal = `<div style='font-weight: 500;line-height: 20px;color: @text-color-secondary;'>${params[0].name}</div>`

              for (var i = 0, l = params.length; i < l; i++) {
                relVal += `<div class="toolTip">${params[i].marker}${params[i].seriesName}：${params[i].value}%</div>`
              }
              return relVal
            },
            confine: true, //是否将 tooltip 框限制在图表的区域内
            enterable: true //鼠标是否可进入提示框浮层中
            // position: function(p) {
            //   // 其中p为当前鼠标的位置
            //   return [p[0] - 10, p[1] - 10]
            // },
          },
          legend: {
            data: titleList,
            padding: [0, 120],
            top: legendTop
          },
          xAxis: {
            type: 'category',
            data: this.chartList.map(item => item.name)
          },
          yAxis: {
            name: this.$t('exam.scoreRate1'),
            nameTextStyle: {
              color: '#333'
            }
          },
          series
        }

        let yTitle = []
        series.forEach(item => {
          yTitle = yTitle.concat(item.data)
        })
        this.beforeEchart(chartObj, 100, { labelFc: () => '%' })
        //let oldLen = 12 / classLen
        this.cScroll(chartObj, chartObj.xAxis.data, 12)

        lineChart.setOption(chartObj)
        lineChart.resize({ height: legendHeight })
      },
      importTo() {
        let { classId, campusId, examIsActive } = this.$route.query
        let classId2 = classId == 0 ? '' : classId
        let url =
          `${ApiXy.defaulteApi.host}` +
          `${ApiXy.defaulteApi.path.competencylevelexport}` +
          `?campusId=${campusId}&seId=` +
          this.$route.query.seId +
          '&subjectId=' +
          this.$route.query.subjectId +
          '&classId=' +
          classId2 +
          '&X-ZYLX-TOKEN=' +
          getCookie('X-ZYLX-TOKEN')

        if (examIsActive * 1) {
          // 如果是联考
          url += '&isUnion=1'
        }

        window.open(url, '_blank', '')
      }
    }
  }
</script>

<style lang="less" scoped>
  /deep/.toolTip {
    height: 32px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 6px 0px 20px 0px rgba(34, 87, 188, 0.1);
    border-radius: @border-radius-base;
    margin: 2px 0;
    padding: 0 8px;
    line-height: 32px;
  }
  .score {
    height: 100%;
    background: #fff;
    .title {
      .left_div {
        margin-left: @padding-lg;
      }
      .right_div {
        margin-right: @padding-lg;
        .btn {
          margin-left: @padding-sm;
        }
      }
    }
    .table_div {
      height: calc(100% - 58px);
      padding: 20px;
      .echartName {
        padding: 0 10%;
        text-align: center;
        font-size: @font-size-lg;
        font-weight: bold;
      }
      /deep/ .ant-table-body {
        border-top: @border-width-base solid #e8e8e8;
        border-bottom: @border-width-base solid #e8e8e8;
        max-width: 100%;
        // max-height: 65vh;
        overflow-x: auto;
        overflow-y: auto;
        &:hover::-webkit-scrollbar-thumb {
          visibility: visible;
        }
        table {
          border-top: 0;
          .ant-table-row-cell-ellipsis {
            width: 120px;
          }
          .scoreRate {
            cursor: pointer;
            color: @primary-color;
            .rate_icon {
              display: inline-block;
              width: 7px;
              height: @padding-sm;
              line-height: @padding-sm;
              margin-left: 6px;
            }
          }
        }
      }
      .echarts {
        margin-top: 32px;
      }
    }
  }

  .chartText {
    display: inline-block;
    opacity: 0;
  }
  .scoreTable {
    margin-top: 20px;
    max-height: 600px;
    overflow: auto;
  }
</style>
